<script setup lang="ts">
/* eslint-disable max-len */
</script>

<template>
  <svg width="135" height="40" viewBox="0 0 135 40" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="r1bxpm390a" x1="60.99%" y1="4.946%" x2="26.536%" y2="71.879%">
        <stop stop-color="#00A0FF" offset="0%" />
        <stop stop-color="#00A1FF" offset="1%" />
        <stop stop-color="#00BEFF" offset="26%" />
        <stop stop-color="#00D2FF" offset="51%" />
        <stop stop-color="#00DFFF" offset="76%" />
        <stop stop-color="#00E3FF" offset="100%" />
      </linearGradient>
      <linearGradient id="qvpv8tvi1b" x1="107.685%" y1="50%" x2="-130.64%" y2="50%">
        <stop stop-color="#FFE000" offset="0%" />
        <stop stop-color="#FFBD00" offset="41%" />
        <stop stop-color="orange" offset="78%" />
        <stop stop-color="#FF9C00" offset="100%" />
      </linearGradient>
      <linearGradient id="q4zjf86p8c" x1="86.271%" y1="30.826%" x2="-50.18%" y2="136.109%">
        <stop stop-color="#FF3A44" offset="0%" />
        <stop stop-color="#C31162" offset="100%" />
      </linearGradient>
      <linearGradient id="idzrramycd" x1="-18.825%" y1="-11.957%" x2="42.086%" y2="35.079%">
        <stop stop-color="#32A071" offset="0%" />
        <stop stop-color="#2DA771" offset="7%" />
        <stop stop-color="#15CF74" offset="48%" />
        <stop stop-color="#06E775" offset="80%" />
        <stop stop-color="#00F076" offset="100%" />
      </linearGradient>
    </defs>
    <g fill-rule="nonzero" fill="none">
      <rect fill="#000" width="135" height="40" rx="5" />
      <path
        d="M130 .8a4.2 4.2 0 0 1 4.2 4.2v30a4.2 4.2 0 0 1-4.2 4.2H5A4.2 4.2 0 0 1 .8 35V5A4.2 4.2 0 0 1 5 .8h125m0-.8H5a5 5 0 0 0-5 5v30a5 5 0 0 0 5 5h125a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5z"
        fill="#A6A6A6"
      />
      <path
        d="M47.42 10.24a2.72 2.72 0 0 1-.75 2 2.9 2.9 0 0 1-2.2.88 3 3 0 0 1-2.21-.9 3 3 0 0 1-.91-2.22 3 3 0 0 1 .91-2.23 3.16 3.16 0 0 1 3.44-.65c.36.148.682.377.94.67l-.53.53a2 2 0 0 0-1.64-.72 2.32 2.32 0 0 0-2.33 2.4 2.36 2.36 0 0 0 4 1.73 1.93 1.93 0 0 0 .51-1.22h-2.18v-.72h2.91c.022.15.036.3.04.45zM52 7.74h-2.7v1.9h2.46v.72H49.3v1.9H52V13h-3.48V7H52zM55.28 13h-.77V7.74h-1.68V7H57v.74h-1.72zM59.94 13V7h.77v6zM64.13 13h-.77V7.74h-1.68V7h4.12v.74h-1.67zM73.61 12.22a3.11 3.11 0 0 1-4.4 0 3 3 0 0 1-.88-2.22 3 3 0 0 1 .88-2.22 2.93 2.93 0 0 1 2.2-.91 3 3 0 0 1 2.2.91c.58.59.898 1.392.88 2.22a3 3 0 0 1-.88 2.22zm-3.83-.5a2.29 2.29 0 0 0 3.26 0 2.36 2.36 0 0 0 .67-1.72A2.36 2.36 0 0 0 73 8.28a2.29 2.29 0 0 0-3.26 0 2.36 2.36 0 0 0-.63 1.72 2.36 2.36 0 0 0 .67 1.72zM75.58 13V7h.93l2.92 4.67V7h.77v6h-.8l-3.05-4.89V13z"
        stroke="#FFF"
        stroke-width=".2"
        fill="#FFF"
      />
      <path
        d="M68.14 21.75A4.26 4.26 0 1 0 72.41 26a4.19 4.19 0 0 0-4.27-4.25zm0 6.83a2.58 2.58 0 1 1 2.4-2.58 2.46 2.46 0 0 1-2.4 2.58zm-9.32-6.83A4.26 4.26 0 1 0 63.09 26a4.19 4.19 0 0 0-4.27-4.25zm0 6.83a2.58 2.58 0 1 1 2.4-2.58 2.46 2.46 0 0 1-2.4 2.58zm-11.08-5.52v1.8h4.32a3.77 3.77 0 0 1-1 2.27 4.42 4.42 0 0 1-3.34 1.32 4.8 4.8 0 1 1 0-9.6A4.64 4.64 0 0 1 51 20.14l1.27-1.27a6.3 6.3 0 0 0-4.53-1.82 6.61 6.61 0 1 0 0 13.21 6.07 6.07 0 0 0 4.61-1.85 6 6 0 0 0 1.56-4.23 6.27 6.27 0 0 0-.09-1.12h-6.08zm45.31 1.4a4 4 0 0 0-3.64-2.71 4 4 0 0 0-4 4.25 4.23 4.23 0 0 0 7.76 2.37l-1.45-1a2.41 2.41 0 0 1-2.09 1.17 2.15 2.15 0 0 1-2.06-1.29l5.69-2.35-.21-.44zm-5.8 1.42a2.33 2.33 0 0 1 2.23-2.48 1.64 1.64 0 0 1 1.57.9l-3.8 1.58zM82.63 30h1.87V17.5h-1.87V30zm-3.06-7.3h-.07a2.94 2.94 0 0 0-2.24-.95 4.26 4.26 0 0 0 0 8.51 2.88 2.88 0 0 0 2.24-1h.07v.61c0 1.63-.87 2.5-2.27 2.5a2.36 2.36 0 0 1-2.15-1.51l-1.62.67a4 4 0 0 0 3.77 2.52c2.19 0 4-1.29 4-4.43V22h-1.73v.7zm-2.15 5.88a2.58 2.58 0 0 1 0-5.15A2.39 2.39 0 0 1 79.7 26a2.38 2.38 0 0 1-2.28 2.58zm24.39-11.08h-4.48V30h1.87v-4.74h2.61a3.89 3.89 0 1 0 0-7.76zm0 6H99.2v-4.26h2.65a2.14 2.14 0 0 1 0 4.28l-.04-.02zm11.54-1.79a3.49 3.49 0 0 0-3.33 1.91l1.65.69a1.78 1.78 0 0 1 1.71-.91 1.8 1.8 0 0 1 2 1.61v.12a4.18 4.18 0 0 0-1.95-.48c-1.78 0-3.6 1-3.6 2.82a2.89 2.89 0 0 0 3.11 2.75 2.65 2.65 0 0 0 2.38-1.22h.06v1h1.8v-4.81c0-2.19-1.66-3.46-3.79-3.46l-.04-.02zm-.23 6.85c-.61 0-1.46-.31-1.46-1.06 0-1 1.06-1.34 2-1.34a3.32 3.32 0 0 1 1.7.42 2.26 2.26 0 0 1-2.2 2l-.04-.02zM123.74 22l-2.14 5.42h-.06L119.32 22h-2l3.33 7.58-1.9 4.21h2L125.82 22h-2.08zm-16.8 8h1.86V17.5h-1.86V30z"
        fill="#FFF"
      />
      <path
        d="M10.44 7.54a2 2 0 0 0-.44 1.4v22.12a1.94 1.94 0 0 0 .47 1.4l.07.08L22.9 20.15v-.3L10.51 7.47l-.07.07z"
        fill="url(#r1bxpm390a)"
      />
      <path
        d="m27 24.28-4.1-4.13v-.3l4.1-4.13.09.06L32 18.56c1.4.79 1.4 2.09 0 2.89l-4.89 2.78-.11.05z"
        fill="url(#qvpv8tvi1b)"
      />
      <path d="M27.12 24.23 22.9 20 10.44 32.46a1.62 1.62 0 0 0 2.07.07l14.61-8.3" fill="url(#q4zjf86p8c)" />
      <path d="m27.12 15.78-14.61-8.3a1.61 1.61 0 0 0-2.07.06L22.9 20l4.22-4.22z" fill="url(#idzrramycd)" />
      <path
        d="m27 24.13-14.49 8.25a1.66 1.66 0 0 1-2 0l-.07.07.07.08a1.66 1.66 0 0 0 2 0l14.61-8.3-.12-.1z"
        fill="#000"
        opacity=".2"
      />
      <path
        d="M10.44 32.32a2 2 0 0 1-.44-1.41v.15a1.94 1.94 0 0 0 .47 1.4l.07-.07-.1-.07zM32 21.3l-5 2.83.09.1L32 21.44A1.75 1.75 0 0 0 33.06 20 1.86 1.86 0 0 1 32 21.3z"
        fill="#000"
        opacity=".12"
      />
      <path
        d="M12.51 7.62 32 18.7c.54.24.933.723 1.06 1.3A1.75 1.75 0 0 0 32 18.56L12.51 7.48C11.12 6.68 10 7.34 10 8.94v.15c0-1.6 1.12-2.26 2.51-1.47z"
        fill="#FFF"
        opacity=".25"
      />
    </g>
  </svg>
</template>
